import React from 'react'
import styled from 'styled-components'


const WrapperCompanyInfo=styled.div`
    background: #fff;
    padding-top: 180px;
`; 

const CompanyName = styled.h3`
    margin: 0 0 1rem 0;
    text-align: center;
    color: #2196f3; 
    
    font-size: 70px;
    @media (min-width: 700px) {
        text-align: left; 
    }
`;

const WrapperList = styled.ul`
    list-style: none;
    margin:0 0 1rem 0;
    padding:0;
    color: #FFF;
    text-align: center;
    @media (min-width: 700px) {
        text-align: left; 
    }
`;


const AboutInfo = () => (
    <WrapperCompanyInfo>
        <CompanyName>About Us</CompanyName>
        <p>Established in 2018, Realtime Digital Solutions, the operators of getairtime.co.ke, has been providing financial services and solutions in a secure and cost effective way.</p>
       
    </WrapperCompanyInfo>
)

export default AboutInfo